import React, { useState } from 'react';
import { Screen } from '../types';

const ApplicantDetailsScreen = ({ userData, navigateTo }) => {
  const [agreed, setAgreed] = useState(false);
  const profileImage = userData?.photoUrl || null;
  const isDigilockerVerified = !!userData?.verificationId;

  return (
    <div className="ilp-screen gray-bg">
      <div className="ilp-header white-bg">
        <button className="ilp-back-btn" onClick={() => navigateTo(Screen.VerificationMethod)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h2>Applicant Details</h2>
        <div className="ilp-header-spacer"></div>
      </div>

      <div className="ilp-applicant-content">
        {isDigilockerVerified && (
          <div className="ilp-verification-badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
            <span>Verified via DigiLocker</span>
          </div>
        )}

        <div className="ilp-step-indicator">
          <div className="ilp-step-bars">
            <div className="ilp-step-bar filled"></div>
            <div className="ilp-step-bar filled"></div>
            <div className="ilp-step-bar"></div>
            <div className="ilp-step-bar"></div>
            <div className="ilp-step-bar"></div>
          </div>
          <p>Step 2 of 5</p>
        </div>

        <h1>Review your details</h1>
        <p className="ilp-subtitle">Please verify the information retrieved from your DigiLocker verification.</p>

        <div className="ilp-profile-card">
          <div className="ilp-profile-photo">
            {profileImage ? (
              <img src={profileImage} alt="Profile" />
            ) : (
              <div className="ilp-profile-placeholder">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </div>
            )}
            <div className="ilp-verified-badge">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                <path d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>
          <div className="ilp-profile-info">
            <h3>{userData?.name || 'User Name'}</h3>
            <p>Aadhaar: {userData?.aadhaar || 'XXXX-XXXX-XXXX'}</p>
            <div className="ilp-aadhaar-verified">
              <svg width="12" height="12" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 4.925-3.467 9.045-8.104 10.04a.75.75 0 01-.192 0C5.166 16.046 1.7 11.926 1.7 7.001c0-.68.056-1.35.166-2.002zm11.76 3.07a.75.75 0 00-1.06-1.06l-3.89 3.89-.935-.935a.75.75 0 00-1.06 1.06l1.465 1.465a.75.75 0 001.06 0l4.42-4.42z" clipRule="evenodd" />
              </svg>
              <span>{isDigilockerVerified ? 'DigiLocker Verified' : 'Aadhaar Verified'}</span>
            </div>
          </div>
        </div>

        <div className="ilp-details-section">
          <div className="ilp-section-header">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="#2563eb">
              <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
            </svg>
            <h4>Personal Information</h4>
          </div>
          <div className="ilp-details-card">
            {userData?.fatherName && (
              <div className="ilp-detail-row">
                <label>Father's / Guardian's Name</label>
                <p>{userData.fatherName}</p>
              </div>
            )}
            <div className="ilp-detail-row with-icon">
              <div>
                <label>Date of Birth</label>
                <p>{userData?.dob || 'Not available'}</p>
              </div>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2">
                <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <div className="ilp-detail-row">
              <label>Gender</label>
              <p>{userData?.gender || 'Not available'}</p>
            </div>
            {userData?.mobile && (
              <div className="ilp-detail-row with-icon">
                <div>
                  <label>Mobile Number</label>
                  <p>{userData.mobile}</p>
                  <span className="ilp-small-note">Linked with Aadhaar</span>
                </div>
                <div className="ilp-check-circle">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                    <path d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              </div>
            )}
          </div>
        </div>

        {userData?.address && (
          <div className="ilp-details-section">
            <div className="ilp-section-header">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="#2563eb">
                <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 0L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
              </svg>
              <h4>Permanent Address</h4>
            </div>
            <div className="ilp-address-card">
              <div className="ilp-address-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <p>{userData.address}</p>
            </div>
          </div>
        )}

        <p className="ilp-reverify-link">Information incorrect? <button onClick={() => navigateTo(Screen.VerificationMethod)}>Re-verify Aadhaar</button></p>
      </div>

      <div className="ilp-applicant-footer">
        <label className="ilp-checkbox-label">
          <input 
            type="checkbox" 
            checked={agreed} 
            onChange={() => setAgreed(!agreed)}
          />
          <div className={`ilp-checkbox ${agreed ? 'checked' : ''}`}>
            {agreed && (
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                <path d="M5 13l4 4L19 7" />
              </svg>
            )}
          </div>
          <span className="ilp-small">I hereby declare that the information provided above is true to the best of my knowledge and matches my official records.</span>
        </label>

        <button 
          className={`ilp-primary-btn full ${!agreed ? 'disabled' : ''}`}
          disabled={!agreed}
          onClick={() => navigateTo(Screen.FaceMatch)}
        >
          <span>Proceed to Face Verification</span>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ApplicantDetailsScreen;

